import { render, staticRenderFns } from "./TestModal.vue?vue&type=template&id=060bd619&scoped=true"
import script from "./TestModal.vue?vue&type=script&lang=js"
export * from "./TestModal.vue?vue&type=script&lang=js"
import style0 from "./TestModal.vue?vue&type=style&index=0&id=060bd619&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "060bd619",
  null
  
)

export default component.exports